import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  citySearch,
  employementTypeList,
  functionalAreaList,
  jobIndustryList,
  salaryList,
  getLocalities,
  qualificationList,
  jobQuestionList,
  searchSkill,
  educationqualificationList,
  courseSpecializationList,
  jobRoleList,
  uploadJobpostionDetails,
} from "../../action/jobs";
import {
  getStorage,
  onChange,
  setIsRequired,
  setOptions,
  validateForm,
} from "../../utils";
import AsideRightMenu from "../Dashboard/AsideRightMenu";
import { Typeahead } from "react-bootstrap-typeahead";
import moment from "moment";
import NumberFormat from "react-number-format";
import "suneditor/dist/css/suneditor.min.css";
import constant from "../../constant";
import { Link } from "react-router-dom";
import ModalWindow from "../Common/ModalWindow";
import JobsModalList from "./JobsModalList";
import Loader from "../Common/Loader";
import Multiselect from "multiselect-react-dropdown";
import { Select } from "antd";

export default class PostAJob extends Component {
  constructor(props) {
    super(props);
    this.editor = React.createRef();
    const detail = this.props.Data;
    console.log(detail, "deatil");


    this.state = {
      JOB_TITLE: {
        name: "JOB_TITLE",
        value: detail ? detail.JOB_TITLE : "",
        error: "",
        isRequired: true,
      },
      EMPLOYMENT_TYPE: {
        name: "EMPLOYMENT_TYPE",
        value: detail ? detail.EMPLOYMENT_TYPE_ID : "",
        options: [],
        error: "",
        isRequired: true,
      },
      NO_OF_VACANCIES: {
        name: "NO_OF_VACANCIES",
        value: detail ? detail.NO_OF_VACANCIES : "",
        error: "",
        isRequired: true,
      },
      WORK_EXP_MIN: {
        name: "WORK_EXP_MIN",
        value: detail ? detail.WORK_EXP_MIN : "",
        error: "",
        isRequired: true,
      },
      WORK_EXP_MAX: {
        name: "WORK_EXP_MAX",
        value: detail ? detail.WORK_EXP_MAX : "",
        error: "",
        isRequired: true,
      },
      CTC_MIN: {
        name: "CTC_MIN",
        value: detail ? detail.CTC_MIN : "",
        options: [],
        error: "",
        isRequired: true,
      },
      CTC_MAX: {
        name: "CTC_MAX",
        value: detail ? detail.CTC_MAX : "",
        options: [],
        error: "",
        isRequired: true,
      },
      INTERNSHIP_PERIOD: {
        name: "INTERNSHIP_PERIOD",
        value: detail ? detail.INTERNSHIP_PERIOD : "",
        options: [],
        error: "",
        isRequired: true,
      },
      IS_HIDE_SALARY_FROM_CANDIDATE:
        detail &&
          detail.IS_HIDE_SALARY_FROM_CANDIDATE &&
          detail.IS_HIDE_SALARY_FROM_CANDIDATE == "Y"
          ? true
          : false,
      IS_WORK_FROM_HOME:
        detail && detail.IS_WORK_FROM_HOME && detail.IS_WORK_FROM_HOME == "Y"
          ? true
          : false,
      INCLUDE_WALK_IN_DISTANCE:
        detail && detail.IS_INCLUDE_WALK_IN && detail.IS_INCLUDE_WALK_IN == "Y"
          ? true
          : false,
      WORK_FROM_HOME_TYPE: {
        name: "WORK_FROM_HOME_TYPE",
        value:
          // function () {
          //   if (detail.TYPE_OF_WORK_FROM_HOME && detail.TYPE_OF_WORK_FROM_HOME == "WFHDC") {
          //     return "DURING_COVID"
          //   }
          //   else if (detail.TYPE_OF_WORK_FROM_HOME && detail.TYPE_OF_WORK_FROM_HOME == "PRJ") {
          //     return "PERMANENT"
          //   }
          //   else {
          //     return ""
          //   }
          // }()
          detail &&
            detail.TYPE_OF_WORK_FROM_HOME &&
            detail.TYPE_OF_WORK_FROM_HOME == "WFHDC"
            ? "DURING_COVID"
            : detail &&
              detail.TYPE_OF_WORK_FROM_HOME &&
              detail.TYPE_OF_WORK_FROM_HOME == "PRJ"
              ? "PERMANENT"
              : ""
        ,
        error: "",
        isRequired: false,
      },
      KEYWORDS: {
        name: "KEYWORDS",
        value: detail ? detail.KEYWORDS : [],
        options: [],
        error: "",
        isRequired: true,
      },
      OTHER_SALARY_DETAILS: {
        name: "OTHER_SALARY_DETAILS",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },
      JOB_LOCATIONS: {
        name: "JOB_LOCATIONS",
        value: "",
        options: [],
        error: "",
        isRequired: false,
      },
      INDUSTRY_ID: {
        name: "INDUSTRY_ID",
        value: detail ? detail.INDUSTRY_ID : "",
        options: [],
        error: "",
        isRequired: true,
      },
      FUNCTIONAL_AREA_ID: {
        name: "FUNCTIONAL_AREA_ID",
        value: detail ? detail.FUNCTIONAL_AREA_ID : "",
        options: [],
        error: "",
        isRequired: true,
      },
      REFERENCE_CODE: {
        name: "REFERENCE_CODE",
        value: detail ? detail.REFERENCE_CODE : "",
        options: [],
        error: "",
        isRequired: false,
      },
      LOCALITIES: {
        name: "LOCALITIES",
        value: detail ? detail.JOB_LOCATIONS : [],
        options: [],
        error: "",
        isRequired: false,
      },
      CITY: {
        name: "CITY",
        value: detail ? detail.CITY_ID : [],
        options: [],
        error: "",
        isRequired: true,
      },
      WALK_IN_START_DATE: {
        name: "WALK_IN_START_DATE",
        value: detail ? detail.WALK_IN_START_DATE : "",
        options: [],
        error: "",
        isRequired: false,
      },
      WALK_IN_START_TIME: {
        name: "WALK_IN_START_TIME",
        value: detail ? detail.WALK_IN_START_TIME : "",
        options: [],
        error: "",
        isRequired: false,
      },
      WALK_IN_END_TIME: {
        name: "WALK_IN_END_TIME",
        value: detail ? detail.WALK_IN_END_TIME : "",
        options: [],
        error: "",
        isRequired: false,
      },
      DURATION: {
        name: "DURATION",
        value: detail ? detail.DURATION : "",
        options: [],
        error: "",
        isRequired: false,
      },
      CONTACT_PERSON: {
        name: "CONTACT_PERSON",
        value: detail ? detail.CONTACT_PERSON : "",
        options: [],
        error: "",
        isRequired: false,
      },
      MOBILE_NUMBER: {
        name: "MOBILE_NUMBER",
        value: detail ? detail.MOBILE_NUMBER : "",
        options: [],
        error: "",
        isRequired: false,
      },
      VENUE: {
        name: "VENUE",
        value: detail ? detail.VENUE : "",
        options: [],
        error: "",
        isRequired: false,
      },
      GOOGLE_MAP_URL: {
        name: "GOOGLE_MAP_URL",
        value: detail ? detail.GOOGLE_MAP_URL : "",
        options: [],
        error: "",
        isRequired: false,
      },
      COMPANY_NAME: {
        name: "COMPANY_NAME",
        value: detail ? detail.COMPANY_NAME : "",
        options: [],
        error: "",
        isRequired: false,
      },
      CLIENT_NAME: {
        name: "CLIENT_NAME",
        value: detail ? detail.CLIENT_NAME : "",
        options: [],
        error: "",
        isRequired: false,
      },
      CLIENT_DETAILS: {
        name: "CLIENT_DETAILS",
        value: detail ? detail.CLIENT_DETAILS : "",
        options: [],
        error: "",
        isRequired: false,
      },
      ADDRESS: {
        name: "ADDRESS",
        value: detail ? detail.ADDRESS : "",
        options: [],
        error: "",
        isRequired: false,
      },

      JOB_DESCRIPTION: {
        name: "JOB_DESCRIPTION",
        value: detail ? detail.JOB_DETAILS : "",
        options: [],
        error: "",
        isRequired: true,
      },
      JOB_ROLE: {
        name: "JOB_ROLE",
        value: detail ? detail.ROLE_ID : "",
        options: [],
        error: "",
        isRequired: true,
      },
      POSITION_DETAIL_URL: {
        name: "POSITION_DETAIL_URL",
        value: detail ? detail.POSITION_DETAIL_URL : "",
        options: [],
        error: "",
        isRequired: false,
      },
      LISTNING_TYPE: {
        name: "LISTNING_TYPE",
        value: detail ? detail.LISTNING_TYPE : props.LISTNING_TYPE,
        options: [
          { value: "1", name: "Regular" },
          { value: "2", name: "Featured" },
          { value: "3", name: "Premium" },
        ],
        error: "",
        isRequired: false,
      },
      selectedCity: detail ? detail.CITY_ID : [],
      SELECTED_SKILLS: detail ? detail.KEYWORDS : [],
      SELECTED_QUESTIONS: [],

      SELECTED_QUALIFICATION: {
        value: detail ? detail.QUALIFICATION_ID.map((data, index) => {
          return {
            QUALIFICATION_ID: data.QUALIFICATION_ID,
            QUALIFICATION_NAME: data.QUALIFICATION_NAME,
            label: data.QUALIFICATION_NAME
          }
        }) : [], name: 'SELECTED_QUALIFICATION', error: "",
        isRequired: true
      },

      SELECTED_EDUCATION_QUALIFICATION: detail
        ? detail.EDUCATION_QUALIFICATION_ID.map((data, index) => {
          return {
            EDUCATION_QUALIFICATION_ID: data.EDUCATION_QUALIFICATION_ID,
            COURSE_STREAM: data.COURSE_STREAM,
            label: data.COURSE_STREAM
          }
        })
        : [],
      SELECTED_COURSE_SPECIALIZATION: detail
        ? detail.COURSE_SPECIALIZATION.map((data, index) => {
          return {
            SPECIALIZATION_ID: data.SPECIALIZATION_ID,
            SPECIALIZATION: data.SPECIALIZATION,
            label: data.SPECIALIZATION
          }
        })
        : [],
      fileuploadpercent: 0,
      showprogressbartype: "",
      errorName: "",
      showModal: false,
      QuestionList: [],
      QualificationList: [],
      EducationQualificationList: [],
      SPECIALIZATIONList: [],
      //  selectedQuestions: [],
      KEYWORD: '',
      searchKey: false,
      QualificationsearchKey: false,
      EducationQualificationsearchKey: false,
      SPECIALIZATIONsearchKey: false
    };
    this.Qtypeahead = React.createRef();
    this.questypeahead = React.createRef();
    this.Edutypeahead = React.createRef();
  }
  componentDidMount() {
    this.getEducationQualificationList(this.state.SELECTED_QUALIFICATION.value.map((i) => {
      return i.QUALIFICATION_ID
    }))
    this.getQualificationList()
    this.getcourseSpecializationList(this.state.SELECTED_EDUCATION_QUALIFICATION.map((i) => {
      return i.EDUCATION_QUALIFICATION_ID
    }))
    this.loadlist();
    if (this.props?.Data?.FUNCTIONAL_AREA_ID) {
      const functionalAreaId = this.props.Data.FUNCTIONAL_AREA_ID;
      jobRoleList(functionalAreaId).then((res) => {
        if (res.status) {
          setOptions(this, "JOB_ROLE", res.result);
        } else {
          alert(res.error);
        }
      });
    }
  }
  getQualificationList = (e) => {
    qualificationList({ KEYWORD: e }).then((res) => {
      if (res.status) {
        let d = res.result && res.result.map((data, index) => {
          return {
            QUALIFICATION_ID: data.QUALIFICATION_ID,
            QUALIFICATION_NAME: data.QUALIFICATION_NAME,
            label: data.QUALIFICATION_NAME
          }
        })
        this.setState({
          QualificationList: d || [],
          QualificationsearchKey: true,
        })
      }
    });

  }
  getcourseSpecializationList = (list) => {
    courseSpecializationList(list).then((res) => {
      console.log(res.result, "resultcourseSpecializationList");
      if (res.status) {
        let d = res.result && res.result.map((data, index) => {
          return {
            SPECIALIZATION_ID: data.SPECIALIZATION_ID,
            SPECIALIZATION: data.SPECIALIZATION,
            label: data.SPECIALIZATION
          }
        })
        this.setState({
          SPECIALIZATIONList: d || [],
          SPECIALIZATIONsearchKey: true
        })
      }
    });

  }
  getEducationQualificationList = (list) => {
    educationqualificationList(list).then((res) => {
      if (res.status) {
        let d = res.result && res.result.map((data, index) => {
          return {
            EDUCATION_QUALIFICATION_ID: data.EDUCATION_QUALIFICATION_ID,
            COURSE_STREAM: data.COURSE_STREAM,
            label: data.COURSE_STREAM
          }
        })
        this.setState({
          EducationQualificationList: d || [],
          EducationQualificationsearchKey: true
        })
      }
    });

  }
  getJobQuestion = () => {
    jobQuestionList(this.state.KEYWORD).then((res) => {
      if (res.status) {
        let d = res.result && res.result.map((data, index) => {
          return {
            QUESTION_ID: data.QUESTION_ID,
            QUESTION: data.QUESTION,
            label: data.QUESTION
          }
        })
        this.setState({
          QuestionList: d || [],
          searchKey: true
        })
      }
    });

  }
  onChange = (e) => {
    const { name, value } = e.target;
    if (name === "FUNCTIONAL_AREA_ID") {
      jobRoleList(value).then((res) => {
        if (res.status) {
          setOptions(this, "JOB_ROLE", res.result);
        } else {
          alert(res.error);
        }
      });
    }
    onChange(this, name, value);
  };

  handleCheckBox = (e) => {
    const { DURATION, WALK_IN_START_DATE, VENUE, INCLUDE_WALK_IN_DISTANCE } = this.state;
    if (e.target.checked) {
      this.setState({ INCLUDE_WALK_IN_DISTANCE: !INCLUDE_WALK_IN_DISTANCE });
      setIsRequired(this, WALK_IN_START_DATE.name, true);
      setIsRequired(this, VENUE.name, true);
      setIsRequired(this, DURATION.name, true);
    } else {
      this.setState({ INCLUDE_WALK_IN_DISTANCE: !INCLUDE_WALK_IN_DISTANCE });
      setIsRequired(this, WALK_IN_START_DATE.name, false);
      setIsRequired(this, VENUE.name, false);
      setIsRequired(this, DURATION.name, false);
    }
  };
  onPrefillData = (data) => {
    const { SELECTED_QUALIFICATION, INCLUDE_WALK_IN_DISTANCE, KEYWORDS } = this.state
    console.log(data, 'data');
    this.getEducationQualificationList(data.QUALIFICATION_ID.map((i) => {
      return i.QUALIFICATION_ID
    }))
    // this.getQualificationList()
    this.getcourseSpecializationList(data.EDUCATION_QUALIFICATION_ID.map((i) => {
      return i.EDUCATION_QUALIFICATION_ID
    }))
    onChange(this, "JOB_TITLE", data.JOB_TITLE);
    onChange(this, "EMPLOYMENT_TYPE", data.EMPLOYMENT_TYPE_ID);
    onChange(this, " IS_WORK_FROM_HOME", data.IS_WORK_FROM_HOME);
    onChange(this, "NO_OF_VACANCIES", data.NO_OF_VACANCIES);
    onChange(this, "WORK_EXP_MIN", data.WORK_EXP_MIN);
    onChange(this, "WORK_EXP_MAX", data.WORK_EXP_MAX);
    onChange(this, "CTC_MIN", data.CTC_MIN);
    onChange(this, "CTC_MAX", data.CTC_MAX);
    onChange(
      this,
      "IS_HIDE_SALARY_FROM_CANDIDATE",
      data.IS_HIDE_SALARY_FROM_CANDIDATE
    );
    this.setState({ INCLUDE_WALK_IN_DISTANCE: data.IS_INCLUDE_WALK_IN == "Y" ? true : false })
    // onChange(this,"INCLUDE_WALK_IN_DISTANCE",
    // data.IS_INCLUDE_WALK_IN.value =='Y' ? true: false );

    onChange(this, "WORK_FROM_HOME_TYPE", data.TYPE_OF_WORK_FROM_HOME);
    onChange(
      this,
      "KEYWORDS",
      this.setState({
        SELECTED_SKILLS: data.KEYWORDS,
      })
    );
    onChange(this, KEYWORDS.name, data.KEYWORDS,);
    onChange(this, SELECTED_QUALIFICATION.name, data.QUALIFICATION_ID)

    onChange(this, "OTHER_SALARY_DETAILS", data.OTHER_SALARY_DETAILS == 'null' ? '' : data.OTHER_SALARY_DETAILS);
    onChange(this, "JOB_LOCATIONS", data.JOB_LOCATIONS);
    onChange(this, "INDUSTRY_ID", data.INDUSTRY_ID);
    onChange(this, "FUNCTIONAL_AREA_ID", data.FUNCTIONAL_AREA_ID);
    onChange(this, "REFERENCE_CODE", data.REFERENCE_CODE == 'null' ? '' : data.REFERENCE_CODE);
    // onChange(
    //   this,
    //   "QUALIFICATION_ID",
    //   this.setState({
    //     SELECTED_QUALIFICATION: data.QUALIFICATION_ID,
    //   })
    // );
    onChange(this, "LOCALITIES", data.JOB_LOCATIONS);
    onChange(this, "CITY", data.CITY_ID);
    onChange(this, "WALK_IN_START_DATE", data.WALK_IN_START_DATE == 'null' ? '' : data.WALK_IN_START_DATE);
    onChange(this, "WALK_IN_START_TIME", data.WALK_IN_START_TIME == 'null' ? '' : data.WALK_IN_START_TIME);
    onChange(this, "WALK_IN_END_TIME", data.WALK_IN_END_TIME == "null" ? '' : data.WALK_IN_END_TIME);
    onChange(this, "DURATION", data.DURATION == "null" ? '' : data.DURATION);
    onChange(this, "CONTACT_PERSON", data.CONTACT_PERSON == "null" ? "" : data.CONTACT_PERSON);
    onChange(this, "MOBILE_NUMBER", data.MOBILE_NUMBER == 'null' ? '' : data.MOBILE_NUMBER);
    onChange(this, "VENUE", data.VENUE == "null" ? 'NA' : data.VENUE);
    onChange(this, "GOOGLE_MAP_URL", data.GOOGLE_MAP_URL == "null" ? '' : data.GOOGLE_MAP_URL);
    onChange(this, "COMPANY_NAME", data.COMPANY_NAME == 'null' ? '' : data.COMPANY_NAME);
    onChange(this, "CLIENT_NAME", data.CLIENT_NAME == "null" ? '' : data.CLIENT_NAME);
    onChange(this, "CLIENT_DETAILS", data.CLIENT_DETAILS == "null" ? '' : data.CLIENT_DETAILS);
    onChange(this, "ADDRESS", data.ADDRESS == "null" ? "" : data.ADDRESS);
    onChange(
      this,
      "QUESTION",
      this.setState({
        SELECTED_QUESTIONS: data.QUESTION_ID,
      })
    );
    onChange(
      this,
      "EDUCATION_QUALIFICATION",
      this.setState({
        SELECTED_EDUCATION_QUALIFICATION: data.EDUCATION_QUALIFICATION_ID,
      })
    );
    onChange(
      this,
      "COURSE_SPECIALIZATION",
      this.setState({
        SELECTED_COURSE_SPECIALIZATION: data.COURSE_SPECIALIZATION,
      })
    );
    onChange(this, "JOB_DESCRIPTION", data.JOB_DETAILS == "null" ? "" : data.JOB_DETAILS);
    onChange(this, "JOB_ROLE", data.ROLE_ID);
    onChange(this, "POSITION_DETAIL_URL", data.POSITION_DETAIL_URL == "null" ? "" : data.POSITION_DETAIL_URL);
  };
  onSubmit = (e) => {

    e.preventDefault();
    const {
      IS_WORK_FROM_HOME,
      WORK_FROM_HOME_TYPE,
      SELECTED_SKILLS,
      SELECTED_QUALIFICATION

    } = this.state;
    if (IS_WORK_FROM_HOME) {
      setIsRequired(this, WORK_FROM_HOME_TYPE.name, true);
    }
    if (!IS_WORK_FROM_HOME) {
      setIsRequired(this, WORK_FROM_HOME_TYPE.name, false);
    }

    if (SELECTED_SKILLS.length > 0) {
      onChange(this, "KEYWORDS", SELECTED_SKILLS);
    }
    if (validateForm(this)) {
      const {
        JOB_TITLE,
        EMPLOYMENT_TYPE,
        NO_OF_VACANCIES,
        WORK_EXP_MIN,
        WORK_EXP_MAX,
        CTC_MIN,
        CTC_MAX,
        IS_HIDE_SALARY_FROM_CANDIDATE,
        WORK_FROM_HOME_TYPE,
        IS_WORK_FROM_HOME,
        INDUSTRY_ID,
        LISTNING_TYPE,
        FUNCTIONAL_AREA_ID,
        REFERENCE_CODE,
        LOCALITIES,
        CITY,
        INCLUDE_WALK_IN_DISTANCE,
        WALK_IN_START_DATE,
        WALK_IN_START_TIME,
        WALK_IN_END_TIME,
        DURATION,
        CONTACT_PERSON,
        MOBILE_NUMBER,
        VENUE,
        JOB_ROLE,
        COMPANY_NAME,
        GOOGLE_MAP_URL,
        CLIENT_NAME,
        CLIENT_DETAILS,
        ADDRESS,
        SELECTED_QUESTIONS,
        SELECTED_SKILLS,
        SELECTED_QUALIFICATION,
        JOB_DESCRIPTION,
        SELECTED_EDUCATION_QUALIFICATION,
        SELECTED_COURSE_SPECIALIZATION,
        POSITION_DETAIL_URL,
        INTERNSHIP_PERIOD
      } = this.state;

      const model = {
        JOB_TITLE: JOB_TITLE.value,
        NO_OF_VACANCIES: NO_OF_VACANCIES.value,
        EMPLOYMENT_TYPE_ID: EMPLOYMENT_TYPE.value,
        IS_WORK_FROM_HOME: IS_WORK_FROM_HOME ? "Y" : "N",
        IS_WORK_FROM_HOME_DURING_COVID: IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "DURING_COVID" ? "Y" : "N",
        TYPE_OF_WORK_FROM_HOME:
          // function () {
          //   if (IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "DURING_COVID") {
          //     return "WFHDC"
          //   }
          //   else if (IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "PERMANENT") {
          //     return "PRJ"
          //   }
          //   else {
          //     return ""
          //   }
          // }(),
          IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "DURING_COVID" ?
            "WFHDC" : IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "PERMANENT" ? "PRJ" : "",
        WORK_EXP_MIN: WORK_EXP_MIN.value,
        WORK_EXP_MAX: WORK_EXP_MAX.value,
        KEYWORDS: SELECTED_SKILLS,
        JOB_DETAILS: JOB_DESCRIPTION.value,
        CTC_CURRENCY: 1,
        CTC_MIN: CTC_MIN.value,
        CTC_MAX: CTC_MAX.value,
        IS_HIDE_SALARY_FROM_CANDIDATE: IS_HIDE_SALARY_FROM_CANDIDATE,
        INDUSTRY_ID: INDUSTRY_ID.value,
        FUNCTIONAL_AREA_ID: FUNCTIONAL_AREA_ID.value,
        ROLE_ID: JOB_ROLE.value,
        REFERENCE_CODE: REFERENCE_CODE.value,
        QUALIFICATION_ID: SELECTED_QUALIFICATION.value,
        EDUCATION_QUALIFICATION_ID: SELECTED_EDUCATION_QUALIFICATION,
        COURSE_SPECIALIZATION: SELECTED_COURSE_SPECIALIZATION,
        IS_INCLUDE_WALK_IN: INCLUDE_WALK_IN_DISTANCE ? "Y" : "N",
        WALK_IN_START_DATE: INCLUDE_WALK_IN_DISTANCE ? WALK_IN_START_DATE.value : "",
        DURATION: INCLUDE_WALK_IN_DISTANCE ? DURATION.value : "",
        WALK_IN_START_TIME: INCLUDE_WALK_IN_DISTANCE ? WALK_IN_START_TIME.value : "",
        WALK_IN_END_TIME: INCLUDE_WALK_IN_DISTANCE ? WALK_IN_END_TIME.value : "",
        CONTACT_PERSON: INCLUDE_WALK_IN_DISTANCE ? CONTACT_PERSON.value : "",
        MOBILE_NUMBER: INCLUDE_WALK_IN_DISTANCE ? MOBILE_NUMBER.value : "",
        VENUE: INCLUDE_WALK_IN_DISTANCE ? VENUE.value : "",
        GOOGLE_MAP_URL: INCLUDE_WALK_IN_DISTANCE ? GOOGLE_MAP_URL.value : "",
        CLIENT_NAME: CLIENT_NAME.value,
        CLIENT_DETAILS: CLIENT_DETAILS.value,
        ADDRESS: ADDRESS.value,
        COMPANY_NAME: COMPANY_NAME.value,
        POSITION_DETAIL_URL: POSITION_DETAIL_URL.value,
        LISTNING_TYPE: LISTNING_TYPE.value,
        QUESTIONS: SELECTED_QUESTIONS,
        CITY_ID: CITY.value,
        JOB_LOCATIONS: LOCALITIES.value,
        INTERNSHIP_PERIOD: INTERNSHIP_PERIOD.value
      };
      if (this.props.JOB_ID) {
        model.JOB_ID = this.props.JOB_ID;
      }

      console.log(model)
      this.props.onSubmit(model);
    }
  };

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onhideModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const {
      JOB_TITLE,
      EMPLOYMENT_TYPE,
      NO_OF_VACANCIES,
      WORK_EXP_MIN,
      WORK_EXP_MAX,
      CTC_MIN,
      CTC_MAX,
      IS_HIDE_SALARY_FROM_CANDIDATE,
      WORK_FROM_HOME_TYPE,
      KEYWORDS,
      IS_WORK_FROM_HOME,
      INDUSTRY_ID,
      FUNCTIONAL_AREA_ID,
      REFERENCE_CODE,
      QUALIFICATION_ID,
      LOCALITIES,
      CITY,
      INCLUDE_WALK_IN_DISTANCE,
      WALK_IN_START_DATE,
      WALK_IN_START_TIME,
      WALK_IN_END_TIME,
      DURATION,
      CONTACT_PERSON,
      MOBILE_NUMBER,
      VENUE,
      JOB_ROLE,
      COMPANY_NAME,
      GOOGLE_MAP_URL,
      CLIENT_NAME,
      CLIENT_DETAILS,
      ADDRESS,
      QUESTION,
      SELECTED_QUESTIONS,
      SELECTED_SKILLS,
      SELECTED_QUALIFICATION,
      JOB_DESCRIPTION,
      SELECTED_EDUCATION_QUALIFICATION,
      EDUCATION_QUALIFICATION,
      COURSE_SPECIALIZATION,
      SELECTED_COURSE_SPECIALIZATION,
      POSITION_DETAIL_URL,
      showModal,
      selectedQuestions,
      INTERNSHIP_PERIOD


    } = this.state;


    return (
      <React.Fragment>
        {this.props.showLoader && <Loader />}
        <section className="pricing-area padding-top-100px padding-bottom-80px">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mt-3">
                <AsideRightMenu />
              </div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="breadcrumb-content d-flex flex-wrap justify-content-between align-items-center">
                      <ul className="list-items d-flex align-items-center">
                        <li className="active__list-item">
                          <a
                            href={constant.component.Dashboard.url}
                            className="text-secondary"
                          >
                            Home
                          </a>
                        </li>
                        <li className="active__list-item text-secondary">
                          Dashboard
                        </li>
                        <li className=" text-secondary">Post a Campus Internship</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <div className="billing-form-item mb-0">
                      <div className="billing-title-wrap">
                        <h3 className="widget-title pb-0">Post a Campus Internship </h3>
                        <div className="title-shape margin-top-5px"></div>
                      </div>
                      <div className="billing-content">
                        <div className="postjob-form-action">
                          <form onSubmit={this.onSubmit}>
                            <div className="row">

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Internship title    {" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        JOB_TITLE.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      placeholder="Mention the designation or role"
                                      name={JOB_TITLE.name}
                                      value={JOB_TITLE.value}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Employment Type{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      // className="postjob-select"
                                      className={
                                        EMPLOYMENT_TYPE.error.length > 0
                                          ? "form-control is-invalid postjob-select"
                                          : "form-control postjob-select"
                                      }
                                      name={EMPLOYMENT_TYPE.name}
                                      value={EMPLOYMENT_TYPE.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">Select Job Type</option>
                                      {EMPLOYMENT_TYPE.options.length > 0 &&
                                        EMPLOYMENT_TYPE.options.map(
                                          (item, index) => {
                                            return (
                                              <option
                                                key={index}
                                                value={item.EMPLOYMENT_TYPE_ID}
                                              >
                                                {item.EMPLOYMENT_TYPE}
                                              </option>
                                            );
                                          }
                                        )}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12 column-lg-full">
                                <div className="wfh-input-box">
                                  <input
                                    type="checkbox"
                                    checked={IS_WORK_FROM_HOME}
                                    onClick={() =>
                                      this.setState({
                                        IS_WORK_FROM_HOME: !IS_WORK_FROM_HOME,
                                      })
                                    }
                                  />
                                  Work from home / Permanent remote
                                </div>
                                {IS_WORK_FROM_HOME && (
                                  <div className="wfhduring">
                                    <ul>
                                      <li>
                                        <input
                                          type="radio"
                                          checked={
                                            WORK_FROM_HOME_TYPE.value ===
                                            "DURING_COVID"
                                          }
                                          onClick={() =>
                                            onChange(
                                              this,
                                              WORK_FROM_HOME_TYPE.name,
                                              "DURING_COVID"
                                            )
                                          }
                                        />
                                        <div className="wfhheading">
                                          Work from home
                                          <p>
                                            Candidate will temporarily work from
                                            home
                                          </p>
                                        </div>
                                      </li>
                                      <li>
                                        <input
                                          type="radio"
                                          checked={
                                            WORK_FROM_HOME_TYPE.value ===
                                            "PERMANENT"
                                          }
                                          onClick={() =>
                                            onChange(
                                              this,
                                              WORK_FROM_HOME_TYPE.name,
                                              "PERMANENT"
                                            )
                                          }
                                        />
                                        <div className="wfhheading">
                                          Permanent remote job
                                          <p>
                                            Candidate can permanently work from
                                            home
                                          </p>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                              <div className="col-lg-12 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Key Skills{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <p>
                                    Specify key skills required for this job
                                    role
                                  </p>

                                  <div>
                                    {SELECTED_SKILLS.map((item) => {
                                      return (
                                        <span className="locationbox">
                                          {item.SKILL}{" "}
                                          <i
                                            onClick={() => {
                                              this.deleteSKills(item.SKILL);
                                            }}
                                            className="fa fa-close"
                                          ></i>
                                        </span>
                                      );
                                    })}
                                  </div>
                                  <div className="form-group">
                                    <Typeahead
                                      id="ta-skill-ids"
                                      clearButton={false}
                                      labelKey={(option) => `${option.SKILL}`}
                                      multiple={true}
                                      // selected={KEYWORDS.value}
                                      options={KEYWORDS.options}
                                      onInputChange={(e) => {
                                        this.onKeywordPress(e, "SKILL");
                                      }}
                                      onChange={(e) => {
                                        this.skillsOnChange(e);
                                      }}
                                      placeholder="Add New Skill"
                                      className={
                                        KEYWORDS.error.length > 0
                                          ? "errorMsg"
                                          : ""
                                      }
                                      emptyLabel
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text pb-1">
                                    Work Experience (Years){" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="row">
                                    <div className="col-lg-4">
                                      <div className="form-group">
                                        <input
                                          className={
                                            WORK_EXP_MIN.error.length > 0
                                              ? "form-control is-invalid"
                                              : "form-control"
                                          }
                                          type="number"
                                          min="0"
                                          placeholder="Min"
                                          name={WORK_EXP_MIN.name}
                                          value={WORK_EXP_MIN.value}
                                          onChange={this.onChange}
                                        />
                                      </div>
                                    </div>
                                    <span className="mob-span">to</span>
                                    <div className="col-lg-4">
                                      <div className="form-group">
                                        <input
                                          className={
                                            WORK_EXP_MAX.error.length > 0
                                              ? "form-control is-invalid"
                                              : "form-control"
                                          }
                                          type="number"
                                          min="0"
                                          placeholder="Max"
                                          name={WORK_EXP_MAX.name}
                                          value={WORK_EXP_MAX.value}
                                          onChange={this.onChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text pb-1">
                                    Internship Period (Months)
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="form-group postjob-select-container">
                                        <select
                                          className={
                                            INTERNSHIP_PERIOD.error.length > 0
                                              ? "form-control is-invalid postjob-select"
                                              : "form-control postjob-select"
                                          }
                                          name={INTERNSHIP_PERIOD.name}
                                          value={INTERNSHIP_PERIOD.value}
                                          onChange={this.onChange}
                                        >
                                          <option value=''> Select Internship Period</option>
                                          <option value='1 Month'> 1 Month</option>
                                          <option value='2 Month'> 2 Months</option>
                                          <option value='3 Month'> 3 Months</option>
                                          <option value='4 Month'> 4 Months</option>
                                          <option value='5 Month'> 5 Months</option>
                                          <option value='6 Month'> 6 Months</option>
                                          <option value='7 Month'> 7 Months</option>
                                          <option value='8 Month'> 8 Months</option>
                                          <option value='9 Month'> 9 Months</option>
                                          <option value='10 Month'> 10 Months</option>
                                          <option value='11 Month'> 11 Months</option>
                                          <option value='12 Month'> 12 Months</option>


                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text pb-1">
                                    Internship Description{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <textarea
                                          className={
                                            JOB_DESCRIPTION.error.length > 0
                                              ? "errorMsg"
                                              : ""
                                          }
                                          name={JOB_DESCRIPTION.name}
                                          value={JOB_DESCRIPTION.value}
                                          style={{ width: "100%", padding: "10px" }}
                                          onChange={this.onChange}
                                          rows={7}
                                        ></textarea>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text pb-0">
                                    Monthly Stippend {" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  {/* <p>Enter the salary offered for this job</p> */}
                                  <div className="row">
                                    <div className="col-lg-2">
                                      <div className="form-group postjob-select-container">
                                        <select className="postjob-select">
                                          <option value>Rs.</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group postjob-select-container">
                                        <select
                                          // className="postjob-select"
                                          className={
                                            CTC_MIN.error.length > 0
                                              ? "form-control is-invalid postjob-select"
                                              : "form-control postjob-select"
                                          }
                                          name={CTC_MIN.name}
                                          value={CTC_MIN.value}
                                          onChange={this.onChange}
                                        >
                                          <option value="">
                                            Min Monthly Stippend
                                          </option>
                                          {CTC_MIN.options.length > 0 &&
                                            CTC_MIN.options.map(
                                              (item, index) => {
                                                return (
                                                  <option value={item.SALARY}>
                                                    {item.SALARY_DETAILS}
                                                  </option>
                                                );
                                              }
                                            )}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group postjob-select-container">
                                        <select
                                          className={
                                            CTC_MAX.error.length > 0
                                              ? "form-control is-invalid postjob-select"
                                              : "form-control postjob-select"
                                          }
                                          name={CTC_MAX.name}
                                          value={CTC_MAX.value}
                                          onChange={this.onChange}
                                        >
                                          <option value="">
                                            Max Monthly Stippend
                                          </option>
                                          {CTC_MAX.options.length > 0 &&
                                            CTC_MAX.options.map(
                                              (item, index) => {
                                                if (
                                                  Number(item.SALARY) >
                                                  Number(CTC_MIN.value)
                                                )
                                                  return (
                                                    <option value={item.SALARY}>
                                                      {item.SALARY_DETAILS}
                                                    </option>
                                                  );
                                              }
                                            )}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12 column-lg-full">
                                <div class="wfh-input-box">
                                  {/* Entire salary is fixed. It does not include any variable component. <a href='#'>Change</a> */}
                                </div>
                                <div class="wfh-input-box">
                                  <input
                                    type="checkbox"
                                    checked={IS_HIDE_SALARY_FROM_CANDIDATE}
                                    onClick={() =>
                                      this.setState({
                                        IS_HIDE_SALARY_FROM_CANDIDATE:
                                          !IS_HIDE_SALARY_FROM_CANDIDATE,
                                      })
                                    }
                                  />
                                  Hide salary details from candidates
                                </div>
                              </div>
                              <div className="col-lg-12 column-lg-full pt-3">

                                <div className="input-box sq-bd1">
                                  <label className="label-text sq-bd1">
                                    Location{" "}
                                    <span className="text-danger font-size-16 sq-bd1">
                                      *
                                    </span>
                                  </label>
                                  {CITY.value.map((item, index) => {
                                    return (
                                      <span className="locationbox sq-bd1">
                                        {" "}
                                        {item.CITY}{" "}
                                        <i
                                          onClick={() =>
                                            this.deleteLocation(item.CITY)
                                          }
                                          className="fa fa-close sq-bd1"
                                        ></i>
                                      </span>
                                    );
                                  })}
                                  <div className="form-group sq-bd1">
                                    <Typeahead
                                      id="ta-location-ids"
                                      allowNew={false}
                                      labelKey={(option) => `${option.CITY}`}
                                      selected={CITY.value}
                                      multiple={true}
                                      options={CITY.options}
                                      onChange={(e) => {
                                        this.locationOnChange(e);
                                      }}
                                      onInputChange={(e) => {
                                        this.onKeywordPress(e, "LOCATION");
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.code === 'Enter') {
                                          let arg = { ...CITY };
                                          arg = arg.value;
                                          let available = CITY.options.find(item => item.CITY.toLowerCase() === e.target.value.toLowerCase())
                                          let existed = arg.find(item => item.CITY.toLowerCase() === e.target.value.toLowerCase())
                                          if (available && !existed) {
                                            this.locationOnChange([...arg, available]);

                                          }
                                          else if (!available && !existed) {
                                            // this.locationOnChange([...arg, { CITY: e.target.value, CITY_ID: null }]);
                                          }
                                        }
                                      }}
                                      placeholder="Search and add new locations"
                                      emptyLabel
                                      className={
                                        CITY.error.length > 0 ? "errorMsg" : ""
                                      }
                                    />

                                    {/* <input className="form-control" type="text" name="text" placeholder="Search and add locations" /> */}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full pt-3 sq-bd1">
                                <div className="input-box sq-bd1">
                                  <label className="label-text sq-bd1">
                                    Localities
                                  </label>
                                  {LOCALITIES.value.map((item, index) => {
                                    return (
                                      <span className="locationbox sq-bd1">
                                        {" "}
                                        {item.LOCALITY}{" "}
                                        <i
                                          onClick={() =>
                                            this.deleteLocalities(item.LOCALITY)
                                          }
                                          className="fa fa-close"
                                        ></i>
                                      </span>
                                    );
                                  })}
                                  <div className="form-group sq-bd1">
                                    <Typeahead
                                      id="ta-localities-ids"
                                      allowNew={false}
                                      labelKey={(option) =>
                                        `${option.LOCALITY}`
                                      }
                                      selected={LOCALITIES.value}
                                      multiple={true}
                                      options={LOCALITIES.options}
                                      onChange={(e) => {
                                        this.localitiesOnChange(e);
                                      }}
                                      placeholder="Add new localities"
                                      emptyLabel
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full">
                              </div>
                              <div className="col-lg-6 column-lg-full pt-3 sq-db2">
                                <div className="input-box sq-db2">
                                  <label className="label-text sq-db2">
                                    Industry{" "}
                                    <span className="text-danger font-size-16 sq-db2">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container sq-db2">
                                    <select
                                      className={
                                        INDUSTRY_ID.error.length > 0
                                          ? "form-control is-invalid postjob-select sq-db2"
                                          : "form-control postjob-select"
                                      }
                                      name={INDUSTRY_ID.name}
                                      value={INDUSTRY_ID.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">Select Industry</option>
                                      {INDUSTRY_ID.options.length > 0 &&
                                        INDUSTRY_ID.options.map(
                                          (item, index) => {
                                            return (
                                              <option value={item.INDUSTRY_ID}>
                                                {item.INDUSTRY}
                                              </option>
                                            );
                                          }
                                        )}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full pt-3 sq-db3">
                                <div className="input-box sq-db3">
                                  <label className="label-text sq-db3">
                                    Functional Area{" "}
                                    <span className="text-danger font-size-16 sq-db3">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container sq-db3">
                                    <select
                                      className={
                                        FUNCTIONAL_AREA_ID.error.length > 0
                                          ? "form-control is-invalid postjob-select"
                                          : "form-control postjob-select"
                                      }
                                      name={FUNCTIONAL_AREA_ID.name}
                                      value={FUNCTIONAL_AREA_ID.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">
                                        Choose a functional area for your job
                                      </option>
                                      {FUNCTIONAL_AREA_ID.options.length > 0 &&
                                        FUNCTIONAL_AREA_ID.options.map(
                                          (item, index) => {
                                            return (
                                              <option
                                                value={item.FUNCTIONAL_AREA_ID}
                                              >
                                                {item.FUNCTIONAL_AREA}
                                              </option>
                                            );
                                          }
                                        )}
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-5 column-lg-full pt-2 sq-db4">
                                <div className="input-box sq-db4">
                                  <label className="label-text sq-db4">
                                    Role<span className="text-danger sq-db4">*</span>
                                  </label>
                                  <div className="form-group postjob-select-container sq-db4">
                                    {/* <select
                                      className={
                                        JOB_ROLE.error.length > 0
                                          ? "form-control is-invalid postjob-select sq-db4"
                                          : "form-control postjob-select sq-db4"
                                      }
                                      name={JOB_ROLE.name}
                                      value={JOB_ROLE.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">
                                        Choose a functional area for your job
                                      </option>
                                      {JOB_ROLE.options.length > 0 &&
                                        JOB_ROLE.options.map((item, index) => {
                                          return (
                                            <option value={item.ROLE_ID}>
                                              {item.ROLE_NAME}
                                            </option>
                                          );
                                        })}
                                    </select> */}
                                    <Select
                                      className={
                                        JOB_ROLE.error.length > 0
                                          ? "is-invalid"
                                          : ""
                                      }
                                      placeholder="Select Job Role"
                                      style={{ height: '40px' }}
                                      onChange={(e) => {
                                        const available = JOB_ROLE.options.find(item => item.ROLE_NAME.toLowerCase() === (e.length > 0 ? e[e.length - 1].toLowerCase() : ""))
                                        if (available) {
                                          onChange(this, JOB_ROLE.name, available.ROLE_ID)
                                        }
                                        else {
                                          onChange(this, JOB_ROLE.name, e.length > 0 ? e[e.length - 1] : "")
                                        }
                                      }
                                      }
                                      mode="tags"
                                      value={JOB_ROLE.value.length > 0 ? JOB_ROLE.value : undefined}
                                      notFoundContent=""
                                    >
                                      {JOB_ROLE.options.length > 0 &&
                                        JOB_ROLE.options.map((item, index) => {
                                          return (
                                            <Select.Option value={item.ROLE_ID.toString()}>
                                              {item.ROLE_NAME}
                                            </Select.Option>
                                          );
                                        })}
                                    </Select>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-4 column-lg-full pt-2 sq-db5">
                                <div className="input-box sq-db5">
                                  <label className="label-text sq-db5">
                                    Reference code
                                  </label>
                                  <div className="form-group sq-db5">
                                    <input
                                      className="form-control sq-db5"
                                      type="text"
                                      placeholder="Reference Code"
                                      name={REFERENCE_CODE.name}
                                      value={REFERENCE_CODE.value}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 column-lg-full pt-2 sq-db5">
                                <div className="input-box sq-db5">
                                  <label className="label-text sq-db5">
                                    Number of Vacancies{" "}
                                    <span className="text-danger sq-db5">*</span>
                                  </label>
                                  <div className="form-group sq-db5">
                                    <input
                                      className={
                                        NO_OF_VACANCIES.error.length > 0
                                          ? "form-control is-invalid sq-db5"
                                          : "form-control sq-db5"
                                      }
                                      type="number"
                                      min="1"
                                      name={NO_OF_VACANCIES.name}
                                      value={NO_OF_VACANCIES.value}
                                      onChange={this.onChange}
                                      placeholder="Vacancies"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full pt-3">
                                <div className="input-box">
                                  <label className="label-text">
                                    Qualification Type{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>

                                  <div className={SELECTED_QUALIFICATION.error.length > 0 ? "form-control is-invalid" : ''}>
                                    <Multiselect
                                      placeholder='Select Qualification Type'
                                      style={{
                                        optionContainer:
                                          this.state.QualificationsearchKey ? { display: 'block' } : { display: 'none' }
                                      }}
                                      options={this.state.QualificationList}
                                      onSelect={(selectedValue) => {
                                        onChange(this, SELECTED_QUALIFICATION.name, selectedValue)
                                        this.getEducationQualificationList(selectedValue.map((item) => {
                                          return item.QUALIFICATION_ID
                                        }))

                                      }}
                                      onRemove={(selectedValue) => {
                                        onChange(this, SELECTED_QUALIFICATION.name, selectedValue)
                                      }}

                                      onSearch={(e) => {
                                        this.getQualificationList(e)
                                      }
                                      }
                                      selectedValues={SELECTED_QUALIFICATION.value}
                                      displayValue={"QUALIFICATION_NAME"}
                                      name={SELECTED_QUALIFICATION.name}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full pt-3">
                                <div className="input-box">
                                  <label className="label-text">
                                    Educational Qualification
                                  </label>


                                  <div className="form-group postjob-select-container">
                                    <Multiselect
                                      placeholder='Select Educational Qualification'
                                      style={{
                                        optionContainer:
                                          this.state.EducationQualificationsearchKey ? { display: 'block' } : { display: 'none' }
                                      }}
                                      options={this.state.EducationQualificationList}

                                      onSelect={(selectedValue) => {

                                        this.setState({ SELECTED_EDUCATION_QUALIFICATION: selectedValue })
                                        this.getcourseSpecializationList(selectedValue.map((item) => {
                                          return item.EDUCATION_QUALIFICATION_ID
                                        }))
                                      }}
                                      onRemove={(selectedValue) => {
                                        this.setState({ SELECTED_EDUCATION_QUALIFICATION: selectedValue })
                                      }}
                                      onSearch={(e) => {
                                        this.getEducationQualificationList(e)
                                      }
                                      }
                                      selectedValues={SELECTED_EDUCATION_QUALIFICATION}
                                      displayValue={"COURSE_STREAM"}
                                      name={"EDUCATION_QUALIFICATION_ID"}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full pt-3">
                                <div className="input-box">
                                  <label className="label-text">
                                    Course Specialization
                                  </label>

                                  <div className="form-group postjob-select-container">
                                    <Multiselect
                                      placeholder='Select Course Specialization'
                                      style={{
                                        optionContainer:
                                          this.state.SPECIALIZATIONsearchKey ? { display: 'block' } : { display: 'none' }
                                      }}
                                      options={this.state.SPECIALIZATIONList}

                                      onSelect={(selectedValue) => {

                                        this.setState({ SELECTED_COURSE_SPECIALIZATION: selectedValue })
                                      }}
                                      onRemove={(selectedValue) => {
                                        this.setState({ SELECTED_COURSE_SPECIALIZATION: selectedValue })
                                      }}
                                      onSearch={(e) => {
                                        this.getcourseSpecializationList(e)
                                      }
                                      }
                                      selectedValues={SELECTED_COURSE_SPECIALIZATION}
                                      displayValue={"SPECIALIZATION"}
                                      name={"SPECIALIZATION_ID"}
                                    />

                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full pt-2">
                                <div className="input-box">
                                  <div className="wfh-input-box pb-2">
                                    <input
                                      type="checkbox"
                                      name="INCLUDE_WALK_IN_DISTANCE"
                                      checked={INCLUDE_WALK_IN_DISTANCE}
                                      onClick={(e) => this.handleCheckBox(e)}
                                    // onClick={() => this.setState({ INCLUDE_WALK_IN_DISTANCE: !INCLUDE_WALK_IN_DISTANCE })}
                                    />

                                    Include walk-in details
                                  </div>
                                  {INCLUDE_WALK_IN_DISTANCE &&
                                    <div className="row">
                                      <div className="col-lg-4">
                                        <label className="label-text">
                                          Walk-in Start Date{" "}
                                          <span className="text-danger font-size-16">
                                            *
                                          </span>
                                        </label>
                                        <div className="form-group">
                                          <input
                                            className={
                                              WALK_IN_START_DATE.error.length >
                                                0
                                                ? "form-control is-invalid"
                                                : "form-control"
                                            }
                                            type="date"
                                            placeholder="Choose start date"
                                            name={WALK_IN_START_DATE.name}
                                            value={WALK_IN_START_DATE.value}
                                            onChange={this.onChange}
                                            min={moment().format("YYYY-MM-DD")}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-lg-4">
                                        <label className="label-text">
                                          Walk-in start timing
                                        </label>
                                        <div className="form-group ">
                                          <input
                                            className="form-control"
                                            type="time"
                                            placeholder="Choose start date"
                                            name={WALK_IN_START_TIME.name}
                                            value={WALK_IN_START_TIME.value}
                                            onChange={this.onChange}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-lg-4">
                                        <label className="label-text">
                                          Walk-in end timing
                                        </label>
                                        <div className="form-group ">
                                          <input
                                            className="form-control"
                                            type="time"
                                            placeholder="Choose start date"
                                            name={WALK_IN_END_TIME.name}
                                            value={WALK_IN_END_TIME.value}
                                            onChange={this.onChange}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-lg-4">
                                        <label className="label-text">
                                          Duration (Days){" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-group">
                                          <NumberFormat
                                            className={
                                              DURATION.error.length > 0
                                                ? "form-control is-invalid"
                                                : "form-control"
                                            }
                                            // type="number"
                                            placeholder="Duration in days"
                                            name={DURATION.name}
                                            value={DURATION.value}
                                            onChange={this.onChange}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-lg-4 column-lg-full">
                                        <div className="input-box">
                                          <label className="label-text">
                                            Contact Person
                                          </label>
                                          <div className="form-group">
                                            <input
                                              className="form-control"
                                              type="text"
                                              name={CONTACT_PERSON.name}
                                              value={CONTACT_PERSON.value}
                                              onChange={this.onChange}
                                              placeholder="Recruiter name(if available)"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 column-lg-full">
                                        <div className="input-box">
                                          <label className="label-text">
                                            Contact Number
                                          </label>
                                          <div className="form-group">
                                            <NumberFormat
                                              className="form-control"
                                              name={MOBILE_NUMBER.name}
                                              value={MOBILE_NUMBER.value}
                                              onChange={this.onChange}
                                              placeholder="Add mobile number"
                                              maxLength={10}
                                              minLength={10}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6 column-lg-full">
                                        <div className="input-box">
                                          <label className="label-text">
                                            Venue{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <div className="form-group">
                                            <input
                                              className={
                                                VENUE.error.length > 0
                                                  ? "form-control is-invalid"
                                                  : "form-control"
                                              }
                                              type="text"
                                              name={VENUE.name}
                                              value={VENUE.value}
                                              onChange={this.onChange}
                                              placeholder="Type Address Here"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6 column-lg-full">
                                        <div className="input-box">
                                          <label className="label-text">
                                            Google Map URL
                                          </label>
                                          <div className="form-group">
                                            <input
                                              className="form-control"
                                              type="text"
                                              name={GOOGLE_MAP_URL.name}
                                              value={GOOGLE_MAP_URL.value}
                                              onChange={this.onChange}
                                              placeholder="Google Map URL of venue"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>

                              {/* <div className="col-lg-12 column-lg-full pt-3">
                                <div className="recruiterAskQ">
                                  <div className="askquetext">
                                    <h6>
                                      Ask questions to candidates they should
                                      respond to when they are applying
                                    </h6>
                                    <p>
                                      Here are a few suggestions to get you
                                      started
                                    </p>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-12 column-lg-full">
                                      <div className="input-box">
                                        <label className="label-text">
                                          Add Questions
                                        </label>
                                        <div className="form-group">
                                          <Multiselect
                                            placeholder='Select Question'
                                            style={{
                                              optionContainer:
                                                this.state.searchKey ? { display: 'block' } : { display: 'none' }
                                            }}
                                            options={this.state.QuestionList}

                                            onSelect={(selectedValue) => {

                                              this.setState({ SELECTED_QUESTIONS: selectedValue })
                                            }}
                                            onSearch={(e) => {
                                              this.getJobQuestion(e)
                                            }
                                            }
                                            selectedValues={SELECTED_QUESTIONS}
                                            displayValue={"QUESTION"}
                                            name={"QUESTION_ID"}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}

                              {/* <div className="col-lg-12 column-lg-full pt-2">
                                <div className="input-box">
                                  <div className="row">
                                    <div className="col-lg-6 column-lg-full">
                                      <div className="input-box">
                                        <label className="label-text">
                                          Company Name
                                        </label>
                                        <div className="form-group">
                                          <input
                                            className="form-control"
                                            type="text"
                                            name={COMPANY_NAME.name}
                                            value={COMPANY_NAME.value}
                                            placeholder="Mention Company Name"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6 column-lg-full">
                                      <div className="input-box">
                                        <label className="label-text">
                                          Client Name
                                        </label>
                                        <div className="form-group">
                                          <input
                                            className="form-control"
                                            type="text"
                                            name={CLIENT_NAME.name}
                                            value={CLIENT_NAME.value}
                                            onChange={this.onChange}
                                            placeholder="Enter the client name"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}

                              {/* <div className="col-lg-12 column-lg-full pt-3">
                                <div className="input-box">
                                  <label className="label-text">
                                    Client Details Section
                                  </label>
                                  <div className="form-group mb-0">
                                    <textarea
                                      className="message-control form-control user-text-editor"
                                      name={CLIENT_DETAILS.name}
                                      value={CLIENT_DETAILS.value}
                                      onChange={this.onChange}
                                    ></textarea>
                                  </div>
                                </div>
                              </div> */}

                              {/* <div className="col-lg-12 pt-2">
                                <div className="input-box">
                                  <label className="label-text">
                                    Client Company Address
                                  </label>
                                  <div className="form-group mb-0">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={ADDRESS.name}
                                      value={ADDRESS.value}
                                      onChange={this.onChange}
                                      placeholder="Add client company address"
                                    />
                                  </div>
                                </div>
                              </div> */}

                              {/* <div className="col-lg-12 pt-2">
                                <div className="input-box">
                                  <label className="label-text">
                                    Video URL
                                  </label>
                                  <div className="form-group mb-0">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={POSITION_DETAIL_URL.name}
                                      value={POSITION_DETAIL_URL.value}
                                      onChange={this.onChange}
                                      placeholder="Enter URL"
                                    />
                                  </div>
                                </div>
                              </div> */}
                              <div class="row">
                                <div class="col-lg-12 pl-4 pt-5">
                                  <div class="btn-box mt-4 pl-1">
                                    <button
                                      type="submit"
                                      class="theme-btn border-0"
                                    >
                                      <i class="la la-plus"></i> Submit Your Internship
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {showModal && (
          <ModalWindow
            title="SEARCH JOB"
            backdrop="static"
            toggleModal={this.onhideModal}
          >
            <JobsModalList
              onCancel={this.onhideModal}
              onSave={(data) => {
                this.onPrefillData(data);
              }}
            />
          </ModalWindow>
        )}
      </React.Fragment>
    );
  }



  onUploadFile = (e) => {
    const increaseProgress = () => {
      this.setState({ fileuploadpercent: +this.state.fileuploadpercent + 14 });
    };
    setInterval(increaseProgress(), 200);
    this.setState({ showprogressbartype: "success" });
    e.preventDefault();
    let model = new FormData();
    model.append("file", e.target.files[0]);
    uploadJobpostionDetails(model)
      .then((res) => {
        if (res.status) {
          onChange(
            this,
            this.state.POSITION_DETAIL_URL.name,
            res.result.filename
          );
          this.setState({ fileuploadpercent: 100 });

          clearInterval(this.state.fileuploadpercent);
        } else {
          this.setState({
            showprogressbartype: "failure",
            errorName: res.error,
          });
          clearInterval(this.state.fileuploadpercent);
        }
      })
      .catch((err) => {
        this.setState({ showprogressbartype: "failure", errorName: err });
        clearInterval(this.state.fileuploadpercent);
      });
  };




  deleteLocation = (input) => {
    const { CITY } = this.state;
    let arr = CITY.value.filter((item) => {
      if (item.CITY != input) {
        return item;
      }
    });
    const CITY_ID = arr.map((item) => {
      return item.CITY_ID;
    });
    getLocalities({ CITY_ID: CITY_ID }).then((res) => {
      if (res.status) {
        setOptions(this, this.state.LOCALITIES.name, res.result);
      } else {
        alert(res.error);
      }
    });

    onChange(this, "CITY", arr);
  };
  deleteLocalities = (input) => {
    const { LOCALITIES } = this.state;
    let arr = LOCALITIES.value.filter((item) => {
      if (item.LOCALITY != input) {
        return item;
      }
    });

    onChange(this, "LOCALITIES", arr);
  };
  deleteSKills = (SKILL) => {
    const { SELECTED_SKILLS } = this.state;
    let arr = SELECTED_SKILLS.filter((item) => {
      if (item.SKILL != SKILL) {
        return item;
      }
    });
    this.setState({ SELECTED_SKILLS: arr });
  };
  onKeywordPress = (value, TYPE) => {
    if (TYPE === "LOCATION") {
      citySearch(value).then((res) => {
        if (res.status) {
          setOptions(this, this.state.CITY.name, res.result);
        } else {
          alert(res.error);
        }
      });
      // } 
    } else if (TYPE === "SKILL") {
      searchSkill(value).then((res) => {
        if (res.status) {
          setOptions(this, this.state.KEYWORDS.name, res.result);
        } else {
          alert(res.error);
        }
      });
    }
  };

  localitiesOnChange = (e) => {
    onChange(this, this.state.LOCALITIES.name, e);
  };

  skillsOnChange = (e) => {
    function getUniqueListBy(arr, key) {
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    }
    let val = [];
    if (e.length > 0) {
      val = e[e.length - 1];
    }
    onChange(this, this.state.KEYWORDS.name, val);
    if (e[0]) {
      val = this.state.SELECTED_SKILLS.concat(val);
      val = val.map((item, index) => {
        if (item.SKILL) {
          return { SKILL: item.SKILL };
        } else if (item.label) {
          return { SKILL: item.label };
        }
      });
      val = getUniqueListBy(val, "SKILL");
      this.setState({ SELECTED_SKILLS: val });
    }
  };






  locationOnChange = (e) => {
    onChange(this, this.state.CITY.name, e);
    const CITY_ID = e.map((item) => {
      return item.CITY_ID;
    });
    getLocalities({ CITY_ID: CITY_ID }).then((res) => {
      if (res.status) {
        setOptions(this, this.state.LOCALITIES.name, res.result);
      } else {
        alert(res.error);
      }
    });
  };

  loadlist = () => {
    const ud = getStorage(constant.keys.userDetails);
    onChange(this, this.state.COMPANY_NAME.name, ud.COMPANY_NAME);
    employementTypeList()
      .then((res) => {
        if (res.status) {
          setOptions(this, this.state.EMPLOYMENT_TYPE.name, res.result);
        } else {
          alert(res.error);
        }
      })
      .catch((err) => {
        alert(err);
      });

    salaryList()
      .then((res) => {
        if (res.status) {
          setOptions(this, this.state.CTC_MIN.name, res.result);
          setOptions(this, this.state.CTC_MAX.name, res.result);
        } else {
          alert(res.error);
        }
      })
      .catch((err) => {
        alert(err);
      });

    jobIndustryList()
      .then((res) => {
        if (res.status) {
          setOptions(this, this.state.INDUSTRY_ID.name, res.result);
        } else {
          alert(res.error);
        }
      })
      .catch((err) => {
        alert(err);
      });

    functionalAreaList()
      .then((res) => {
        if (res.status) {
          setOptions(this, this.state.FUNCTIONAL_AREA_ID.name, res.result);
        } else {
          alert(res.error);
        }
      })
      .catch((err) => {
        alert(err);
      });


  };
}
